import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByQpCode'
})
export class FilterByQpCodePipe implements PipeTransform {
  transform(items: Array<any>, qpCodes: any = []): Array<any> {
	if (!items) {
		return [];
	}
	if (!qpCodes.length) {
		return items;
	}
	return items.filter(item => {
		return item.qpCodeArray.some(role => {
		return qpCodes.indexOf(role.replace(' ', '')) === -1 ? false : true;
		});
	});
  }
}
